"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var mui_list_1 = require("@nexys/mui-list");
var utils_1 = __importDefault(require("@nexys/utils"));
var Utils = __importStar(require("./utils"));
var MyAutocomplete = function (props) {
    var name = props.name, data = props.data, onChange = props.onChange, _a = props.disabled, disabled = _a === void 0 ? false : _a, id = props.id, label = props.label, _b = props.noOptionsText, noOptionsText = _b === void 0 ? 'No options' : _b, _c = props.placeholder, placeholder = _c === void 0 ? 'Type to search...' : _c, promise = props.promise, getPromise = props.getPromise, _d = props.wait, wait = _d === void 0 ? 400 : _d;
    var _e = react_1.useState(props.options || []), options = _e[0], setOptions = _e[1];
    var _f = react_1.useState(''), inputValue = _f[0], setInputValue = _f[1];
    var memoizedDebounce = react_1.useMemo(function () { return mui_list_1.FilterUtils.debounce(wait); }, [wait]);
    var value = data ? utils_1["default"].ds.get(name.toString(), data) : undefined;
    react_1.useEffect(function () {
        setOptions(props.options || []);
    }, [props.options]);
    if (promise) {
        promise.then(function (x) {
            setOptions(x);
        });
    }
    var handleChange = function (_, newValue) {
        onChange({ name: name.toString(), value: newValue });
    };
    var handleInputChange = function (_, newValue) {
        setInputValue(newValue);
        if (getPromise) {
            memoizedDebounce(function () {
                getPromise({ name: name.toString(), value: newValue }).then(function (result) {
                    return setOptions(result);
                });
            });
        }
    };
    return (react_1["default"].createElement(Autocomplete_1["default"], { id: id ? id : name.toString(), options: options, getOptionLabel: Utils.getOptionLabel, getOptionSelected: function (option, value) {
            return option.id === value.id;
        }, value: value, renderInput: function (params) { return (react_1["default"].createElement(TextField_1["default"], __assign({ label: label }, params, { fullWidth: true }))); }, disabled: disabled, renderOption: function (option) { return option.name; }, onChange: handleChange, onInputChange: handleInputChange, noOptionsText: getPromise && !inputValue ? placeholder : noOptionsText }));
};
exports["default"] = MyAutocomplete;
